module.exports = __webpack_public_path__ + "static/session-replay-d4da543d5c8540e06058d59909af7c3f.png";